import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { CardBody, Container, Row, Card, Table, Badge } from "reactstrap";

//Import Breadcrumb
import BreadCrumb from "../../Components/Common/BreadCrumb";

//redux
import { useParams, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { useSubscribers } from "../../hooks/useAdministration";

const SimplePageAdmin = (props) => {
  const contactId = useParams("id");
  const subscribersQ = useSubscribers();
  const subscribers = useMemo(
    () => subscribersQ.data || [],
    [subscribersQ.data],
  );

  const selectcontact = useMemo(
    () => subscribers.find((item) => item.id === parseInt(contactId.id)) || {},
    [subscribers, contactId.id],
  );

  const email = useMemo(
    () =>
      subscribers.find((item) => item.id === parseInt(contactId.id))?.user ||
      {},
    [subscribers, contactId.id],
  );

  document.title = "Détails Contacts | Le Conseiller du BTP";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={props.t("Détails Abonnés")}
            pageTitle={props.t("Abonnés")}
          />
          <Row>
            <div className="col-xxl-3">
              <Card>
                <CardBody className="p-4">
                  <div>
                    <div className="flex-shrink-0 avatar-md mx-auto">
                      <div className="avatar-title bg-soft-success text-success rounded-circle fs-20">
                        {`${selectcontact.first_name}`.charAt(0)}
                      </div>
                    </div>
                    <div className="mt-4 text-center">
                      <h5 className="mb-1">
                        {selectcontact.first_name +
                          " " +
                          selectcontact.last_name || "(Non renseignée)"}
                      </h5>
                    </div>
                    <div className="table-responsive">
                      <Table className="table mb-0 table-borderless">
                        <tbody>
                          <tr>
                            <th>
                              <span className="fw-medium">
                                {props.t("Nom")}
                              </span>
                            </th>
                            <td>
                              {selectcontact.first_name +
                                " " +
                                selectcontact.last_name || "(Non renseignée)"}
                            </td>
                          </tr>

                          <tr>
                            <th>
                              <span className="fw-medium">
                                {props.t("Email")}
                              </span>
                            </th>
                            <td>{email.email || "(Non renseignée)"}</td>
                          </tr>
                          <tr>
                            <th>
                              <span className="fw-medium">
                                {props.t("Fonction")}
                              </span>
                            </th>
                            <td>
                              <Badge
                                color="danger"
                                style={{ fontSize: "12px" }}
                              >
                                {selectcontact.fonction || "(Non renseignée)"}
                              </Badge>
                            </td>
                          </tr>

                          <tr>
                            <th>
                              <span className="fw-medium">
                                {props.t("Société")}
                              </span>
                            </th>
                            <td>
                              <Badge color="info">
                                {selectcontact.societe || "(Non renseignée)"}
                              </Badge>
                            </td>
                          </tr>

                          <tr>
                            <th>
                              <span className="fw-medium">
                                {props.t("Téléphone")}
                              </span>
                            </th>
                            <td>
                              {selectcontact.telephone || "(Non renseignée)"}
                            </td>
                          </tr>

                          <tr>
                            <th>
                              <span className="fw-medium">
                                {props.t("Adresse")}
                              </span>
                            </th>
                            <td>
                              {selectcontact.adresse +
                                ", " +
                                selectcontact.pays || "(Non renseignée)"}
                            </td>
                          </tr>

                          <tr>
                            <th>
                              <span className="fw-medium">
                                {props.t("Langue")}
                              </span>
                            </th>
                            <td>
                              {selectcontact.langue === "Fr"
                                ? props.t("Français")
                                : props.t("Anglais") || "(Non renseignée)"}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

SimplePageAdmin.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(SimplePageAdmin));
